export const MUI_LICENSE_KEY =
  'ce62dd9fe19ea6ff780bd5381675737bTz03MDcxMSxFPTE3MjA5NjQ2MzgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=';
